const LoginHome = () => import('@/views/login/Login.vue')
const LoginIndex = () => import('@/views/login/pages/index.vue')
const register = () => import('@/views/login/pages/register.vue')
const forgetPassword = () => import('@/views/login/pages/forgetPassword.vue')
const changePassword = () => import('@/views/login/pages/changePassword.vue')

export default {
  path: '/',
  component: LoginHome,
  children: [{
    path: 'login',
    component: LoginIndex
  },
  {
    path: 'register',
    component: register
  },
  {
    path: 'forgetPassword',
    component: forgetPassword
  }, {
    path: 'changePassword',
    component: changePassword
  }
  ]
}



// WEBPACK FOOTER //
// ./src/router/login/index.js